import { bindActionCreators } from '@reduxjs/toolkit';
import _ from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { showMsg } from '../../../../../course/actions/loaderAlert';
import { contentManagementAction } from '../../../../reducers/contentMangementData';
import { ExpansionalPanel } from '../../../ExpansionPanel';
import { ConceptPhase, TestComponent } from '../../../treeComponents/component';
import ChapterLevelContent from '../../../treeComponents/component/ChapterLevelContent';
import { handleDeleteContentFromChapter } from '../../../treeComponents/component/helpers/myLibraryFunctions';
import '../../../../styles/ToggleSwitchStyles.css';
import { getPropertyValue } from '../../../../../../utils';
import { ENTITY_TYPE } from '../../../../Constants/constants';
import CustomInfoIcon from '../../../../../common/CustomInfoIcon';
interface TreeLevelProps {
  classes: any,
  treeNode: any;
  level: number;
  handleCourseComponent?: Function;
  subjectTab: string;
  fromCombo?: boolean;
  phaseIndex: number;
  treeData?:any,
  setTreeData?:Function;
  filterSelectedQuestion?: any;
  setFilterSelectedQuestion?: Function;
  mappedConceptsAndChapter:any;
  childIndex: number;
  activeCoursePlanViewList?: string[];
}

interface TreeLevelState {
  expandNode: boolean;
  isActive: boolean;
}

class TreeLevel extends PureComponent<TreeLevelProps, TreeLevelState> {
  constructor(props: TreeLevelProps) {
    super(props);
    this.state = { 
      expandNode: false,
      isActive: false,
     };
  }

  componentDidMount(): void {
    const isActive = getPropertyValue(this.props, 'treeNode.isActive', false);
    this.setState({ isActive, expandNode: (this.props.activeCoursePlanViewList || []).includes(this.props.treeNode.key) });
  }

  componentDidUpdate(prevProps: Readonly<TreeLevelProps>, prevState: Readonly<TreeLevelState>, prevContext: any): void {
    if (this.props.activeCoursePlanViewList !== prevProps.activeCoursePlanViewList) {
      this.setState({ expandNode: (this.props.activeCoursePlanViewList || []).includes(this.props.treeNode.key) });
    }
  }

  updatePhaseStatus(isActive: boolean, phaseIndex: number): void {
    const { setTreeData, treeData } = this.props;
    const cloneTreeData = JSON.parse(JSON.stringify(treeData));
    cloneTreeData.phases[phaseIndex].isActive = isActive;
    setTreeData && setTreeData({ treeData: cloneTreeData });
  }

  handleToggleClick = () => this.setState({ expandNode: !this.state.expandNode });
  handleExpandOnDrag = () => {
    this.setState({ expandNode: true });
  };
  handleRemoveFilterQuestion = (content: any) => {
    const { filterSelectedQuestion, setFilterSelectedQuestion } = this.props;
    let newFilteredQuestion = filterSelectedQuestion.filter((element: any) => element.id !== content.content_Id);
     if(setFilterSelectedQuestion){ 
         setFilterSelectedQuestion({
           filterSelectedQuestion: [...JSON.parse(JSON.stringify(newFilteredQuestion))],
         });
      }
  };
  handleDeleteContentFromChapter = (contentItem: any) => {
    const { treeData, setTreeData,treeNode } = this.props;
    const conceptPhaseData=treeNode;
    handleDeleteContentFromChapter({ treeData, setTreeData, contentItem, conceptPhaseData });
    this.handleRemoveFilterQuestion(contentItem);
  };
  hasValidChildren = () => this.props.treeNode.children && this.props.treeNode.children.length > 0;

  handleToggle(event: any, treeNode: any): void {
    const isActive = event.currentTarget.checked;
    treeNode.isActive = isActive;
    this.setState({isActive});
    this.updatePhaseStatus(isActive, treeNode.phaseIndex);
  }

  getPadding = () => {
    const { treeNode } = this.props;
    switch (treeNode.key) {
      case 'phase':
        return `20px 2%`;
      case 'week':
        return `22px 4%`;
      case 'chapter':
        return `22px 6% 22px 5%`;
      case 'concept':
        return `0px 2.6% 20px 6.5%`;
      default:
        return `1%`;
    }
  };
  render = () => {
    const { classes } = this.props;
    const { treeNode, level, handleCourseComponent, subjectTab, phaseIndex,mappedConceptsAndChapter,childIndex,treeData } = this.props;
     const showWeeks=_.get(treeData,"displaySettings.showWeeks",true);
     const showTestVisibility=_.get(treeData,"displaySettings.showTestVisibility",false);
    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            borderBottom: "1px solid lightgrey",
            padding: this.getPadding(),
            position:
              treeNode.key === "chapter" || treeNode.key === "concept"
                ? "relative"
                : "initial",
          }}
          className="phase-tree-level"
        >
          <span className="content-box">
            {handleCourseComponent
              ? handleCourseComponent(
                  treeNode.key,
                  subjectTab,
                  this.handleExpandOnDrag,
                  this.handleToggleClick,
                  this.state.expandNode,
                  treeNode,
                  childIndex
                )
              : treeNode.name}
          </span>
          {treeNode.key === ENTITY_TYPE.PHASE && (
            <span className="toggle-phase">
              <span>{this.state.isActive ? 'Deactivate' : 'Activate'} this Phase on Glorifire <span className="infoContainer"><CustomInfoIcon
                            hideCloseIconInPopup={true}
                            infoDialogContentType="Add alternate answer"
                            isInfoIcon={true}
                            isRightArrow={false}
                            isCenterArrow={true}
                            knowMoreAbout={false}
                            dialogTitle={
                              <>
                                <span className="text-initial">Activate Phase on Glorifire</span>
                              </>
                            }
                            dialogPara=""
                            details="Click to know more"
                            isHidePhase={true}
                            htmlElement= {
                              <>
                                <p className="dialog-para-text">The activated phases will be visible to both students and teachers on their respective Glorifire and Glorifire Stakeholder platform.  By default, any phase with a start date beyond the current academic year will be automatically deactivated.</p>
                              </>
                            }
                            toolTipDirection="top" /></span></span>
              <span className="h16">
                <label className='switch'>
                  <input
                    checked={this.state.isActive}
                    onChange={(event)=>this.handleToggle(event, treeNode)}
                    type="checkbox"
                  />
                  <span className="slider round"></span>
                </label>
              </span>
            </span>
          )}
        </div>
        {/* render children on expand button click */}
        {/* child.key !== "chapter" || */}
        {this.state.expandNode &&
          this.hasValidChildren() &&
          treeNode.children.map((child: any, index: number) =>
            ( child.key !== "chapter" &&
              child.key !== "concept") ||
            subjectTab === "All Subjects" ||
            child.subjectName === subjectTab ? (
              <span key={index}>
                <TreeLevel
                    key={child.name}
                    subjectTab={subjectTab}
                    treeNode={child}
                    level={level * 2}
                    handleCourseComponent={handleCourseComponent}
                    phaseIndex={phaseIndex}
                    fromCombo={this.props.fromCombo}
                    mappedConceptsAndChapter={mappedConceptsAndChapter}
                    childIndex={index}
                    activeCoursePlanViewList = {this.props.activeCoursePlanViewList}
                    treeData={treeData} classes={undefined}                />
              </span>
            ) : (
              <></>
            )
          )}

              {this.state.expandNode && treeNode.conceptContent &&
                 <ChapterLevelContent
                      isChapterLevel={false}
                      conceptPhaseData={treeNode}
                      subjectTab={subjectTab}
                      levelContent={treeNode.conceptContent}
                      mappedConceptsAndChapter={mappedConceptsAndChapter}
                    />
              }
              {this.state.expandNode && treeNode.chapterContent &&
                 <ChapterLevelContent
                      isChapterLevel={true}
                      conceptPhaseData={treeNode}
                      subjectTab={subjectTab}
                      levelContent={treeNode.chapterContent}
                      mappedConceptsAndChapter={mappedConceptsAndChapter}
                    />
              }
           
        {this.state.expandNode && ((treeNode.key === "week")||(!showWeeks && treeNode.key === "phase" && treeNode.content )) ? (
                treeNode.content.map((test: any, index: number) => (
            <div>
              <TestComponent
                isExtraTests={false}
                testType={treeNode.key}
                phase={treeNode}
                test={test}
                fromCombo={this.props.fromCombo}
                testIndex={index}
                phaseIndex={phaseIndex}
                showTestVisibility={showTestVisibility}
              />{" "}
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    );
  };
}
// export default TreeLevel;
const mapStateToProps = (state: any) => {
  return {
    bulkDrag: _.get(state, 'courseMangementData.contentManagementData.bulkDrag', {}),
    preFilters: _.get(state, 'courseMangementData.contentManagementData.preFilters', {}),
    getPackageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
    filterSelectedQuestion: _.get(state, 'courseMangementData.contentManagementData.filterSelectedQuestion', []),
    activeCoursePlanViewList: getPropertyValue(state, 'courseMangementData.contentManagementData.activeCoursePlanViewList', []),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setPreFilters: contentManagementAction.setPreFilters,
      setTreeData: contentManagementAction.setTreeData,
      setBulkDrag: contentManagementAction.setBulkDrag,
      setFilterSelectedQuestion: contentManagementAction.setFilterSelectedQuestion,
      showMessage: showMsg,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(TreeLevel);